import { Segmented } from 'antd';
import { useState } from 'react';
import { getFromStorage, storeInLocal } from '../../lib/storage';
import InviteHqPractitioner from '../../modules/SuperAdmin/components/pageComponents/OfficePracticum/InvitePractitioner/InvitePractitioner.page';
import OPCredentials from '../../modules/SuperAdmin/components/pageComponents/OfficePracticum/Credentials/OPCredentials.page';
import HQUserManagementPage from './HQUserManagement.page';
import { useIsOP } from 'src/hooks/misc';

const HQSettings = () => {
  const isOP = useIsOP();
  const [activeButton, setActiveButton] = useState(() => {
    return getFromStorage('hqSettingsSegment') || 'Invite Practitioner';
  });

  const buttons = [
    {
      label: 'Invite Practitioner',
      isActive: activeButton === 'Invite Practitioner',
      onClick: () => setActiveButton('Invite Practitioner'),
    },
    {
      label: 'User Management',
      isActive: activeButton === 'User Management',
      onClick: () => setActiveButton('User Management'),
    },
    ...(isOP
      ? [
          {
            label: 'Credentials',
            isActive: activeButton === 'Credentials',
            onClick: () => setActiveButton('Credentials'),
          },
        ]
      : []),
  ];

  const handleSegmentedTabChange = (value) => {
    setActiveButton(value);
    storeInLocal('hqSettingsSegment', value);
  };

  return (
    <div className={`page-wrapper`}>
      <div className="lg:flex gap-3 justify-between py-3 items-center ">
        <Segmented
          options={buttons.map((button) => ({
            label: button.label,
            value: button.label,
          }))}
          value={activeButton}
          onChange={(value) => {
            handleSegmentedTabChange(value);
          }}
        />
      </div>
      <div>
        {activeButton === 'Invite Practitioner' && (
          <>
            <InviteHqPractitioner isHqAccount={true} />
          </>
        )}
        {activeButton === 'User Management' && (
          <>
            <HQUserManagementPage />
          </>
        )}
        {activeButton === 'Credentials' && isOP && <OPCredentials />}
      </div>
    </div>
  );
};

export default HQSettings;
